import { has, get } from "lodash"
import { sexData } from "./../sex/static.sexData"
import locales from "./../../../content.json"

export const checkIsValidBodyZone = data => {
    const sex = get(data, ["sex", "value"])
    let isValid = false

    if (sex === sexData.male.value)
        Object.keys(bodyZoneData.male).map((key) => {
            if (has(data, ["bodyZone", key]) && get(data, ["bodyZone", key], false))
                isValid = true
        })

    else if (sex === sexData.female.value)
        Object.keys(bodyZoneData.female).map((key) => {
            if (has(data, ["bodyZone", key]) && get(data, ["bodyZone", key], false))
                isValid = true
        })

    else if (sex === sexData.other.value)
        Object.keys(bodyZoneData.other).map((key) => {
            if (has(data, ["bodyZone", key]) && get(data, ["bodyZone", key], false))
                isValid = true
        })

    return isValid
}

const bodyZoneMale = {
    armsBack: {
        value: "armsBack",
        title: locales[window.userLang].arms_back,
        image: "img/male1.png"
    },
    absCore: {
        value: "absCore",
        title: locales[window.userLang].abs_core,
        image: "img/male2.png"
    },
    legs: {
        value: "legs",
        title: locales[window.userLang].legs_glutes,
        image: "img/male3.png"
    },
}

const bodyZoneFemale = {
    armsBack: {
        value: "armsBack",
        title: locales[window.userLang].arms_back,
        image: "img/female1.png"
    },
    absCore: {
        value: "absCore",
        title: locales[window.userLang].abs_core,
        image: "img/female2.png"
    },
    legs: {
        value: "legs",
        title: locales[window.userLang].legs_glutes,
        image: "img/female3.png"
    },
}

export const bodyZoneData = {
    male: bodyZoneMale,
    female: bodyZoneFemale,
    other: bodyZoneFemale,
}